import { GeographyState } from './types';

export const initialGeographyState: GeographyState = {
  countriesList: [],
  statesList: [],
  statuses: {
    isCountriesListLoading: false,
    isStatesListLoading: false,
  },
};
